// extracted by mini-css-extract-plugin
module.exports = {"termsBlock":"OptionNotPossibleConditions_termsBlock__3M7Jm","asterisk":"OptionNotPossibleConditions_asterisk__1xS_j","termsLink":"OptionNotPossibleConditions_termsLink__LLkHT"};